module.exports = __webpack_public_path__ + "static/media/yt.7b9036aa.svg";